<template>
    <div
        data-component="AmsListItemSpecifications"
        class="flex flex-wrap gap-y-4"
        :class="{ 'screen-m:gap-x-16 screen-l:gap-x-24': !isVertical }"
    >
        <div
            v-for="key in SpecificationKeys"
            :key="key"
            class="flex basis-2/4 items-center"
            :class="{
                'screen-m:max-w-[50%]': isVertical,
                'screen-m:basis-auto screen-m:grow-0': !isVertical,
            }"
        >
            <component :is="iconMap[key]" class="w-[22px] h-[22px]" />
            <div class="ml-8 text-text-mobile screen-l:text-text-l-desktop">
                {{ getTableText(item, key) }}
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ComponentOptions, PropType } from 'vue'
import { AmsItem } from '../../services/amsSearch/amsSearch.interface'
import { commonUtils } from '@sunrise/shared'
import MileageSvg from './specificationIcons/mileage.svg'
import TransmissionTypeSvg from './specificationIcons/transmissionType.svg'
import FuelTypeSvg from './specificationIcons/fuelType.svg'
import InitialRegistrationDateSvg from './specificationIcons/initialRegistrationDate.svg'

defineProps({
    item: {
        type: Object as PropType<AmsItem>,
        required: true,
    },
    isVertical: {
        type: Boolean,
        default: false,
    },
})

enum SpecificationKeys {
    Mileage = 'mileage',
    TransmissionType = 'transmissionType',
    InitialRegistraionDate = 'initialRegistrationDate',
    FuelType = 'fuelType',
}

const iconMap: Record<SpecificationKeys, ComponentOptions> = {
    [SpecificationKeys.Mileage]: MileageSvg as unknown as ComponentOptions,
    [SpecificationKeys.InitialRegistraionDate]: InitialRegistrationDateSvg as unknown as ComponentOptions,
    [SpecificationKeys.FuelType]: FuelTypeSvg as unknown as ComponentOptions,
    [SpecificationKeys.TransmissionType]: TransmissionTypeSvg as unknown as ComponentOptions,
}

function getTableText(item: AmsItem, key: SpecificationKeys): string {
    if (!item[key]) {
        return '-/-'
    }

    switch (key) {
        case SpecificationKeys.Mileage:
            return `${commonUtils.thousandSeparator(item[key])} km`
        case SpecificationKeys.InitialRegistraionDate:
            return getInitialRegistrationDateText(item.initialRegistrationDate, item.initialRegistrationDateMonth)
        default:
            return `${item[key]}`
    }
}

function getInitialRegistrationDateText(year: number | string, month?: number): string {
    return month ? `${month}/${year}` : `${year}`
}
</script>
